/**
 * app-search — tipos + validador del search-state global del layout `_app`.
 *
 * Centraliza en la URL los overlays montados a nivel `_app` (de momento, el
 * switcher de cuentas multi-cuenta), de modo que pegar la URL en otro navegador
 * reabre exactamente la misma pantalla/overlay.
 *
 * Patrón: `validateSearch` omite defaults (no contamina la URL en estado vacío)
 * y los hosts reflejan URL→signals + navegan con `{ replace: true }` al
 * abrir/cerrar (idempotente, sobrevive a back/forward y a una URL pegada). Los
 * search de las rutas hijas se fusionan con estos.
 */

export interface AppLayoutSearch {
  // ── Cambio de cuenta (multi-cuenta #18) ─────────────────────────────────────
  /** Switcher de cuentas abierto (`?account=switch`). */
  account?: "switch";
}

/**
 * Valida + normaliza el search del layout. Omite defaults para mantener la URL
 * limpia. Tolerante: valores desconocidos se descartan (no rompe el render).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};

  // ── Switcher de cuentas (multi-cuenta) ──
  if (search.account === "switch") {
    out.account = "switch";
  }

  return out;
}
